import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../hooks/useTitle";
import { withAuth } from "../../../../components/HOC/withAuth";
import CardContainer from "../../../../components/CustomUI/CardContainer";
import { useNavigate } from "react-router-dom";
import IconButton from "../../../../components/BaseUI/Button/IconButton";
import { FiPlus } from "react-icons/fi";
import { SectionSpinner, SectionEmpty, fmtMins } from "../shared/utils";
import DowntimeReportShell from "./DowntimeReportShell";
import { useDowntimeReport } from "./useDowntimeReport";

const DowntimeByMachineReport = () => {
  useTitle("Rovion MES - Makine Duruş Raporu");
  const {
    filters,
    machines,
    shifts,
    stopLogs,
    loading,
    derived,
    fetchData,
    toasts,
    dismissToast,
  } = useDowntimeReport();

  const navigate = useNavigate();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!stopLogs.length || !derived) return <SectionEmpty />;
    const { machineArr } = derived;
    if (!machineArr.length)
      return <SectionEmpty msg="Makine verisi bulunamadı." />;

    return (
      <CardContainer title="Makine Duruş Raporu">
        <div style={{ position: "relative" }}>
          <ReactApexChart
            type="bar"
            series={[
              {
                name: "Duruş (dk)",
                data: machineArr.map(([, v]) => v.minutes),
              },
            ]}
            options={{
              chart: {
                type: "bar",
                toolbar: { show: false },
                events: {
                  dataPointSelection: (event, chartContext, config) => {
                    const idx = config.dataPointIndex;
                    if (idx !== undefined && machineArr[idx]) {
                      const data = machineArr[idx][1];
                      const name = machineArr[idx][0];
                      if (data.id) {
                        navigate("/epc", {
                          state: {
                            machine: { _id: data.id, name: name },
                            action: "scrap",
                          },
                        });
                      }
                    }
                  },
                },
              },
              plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
              colors: ["#e74c3c"],
              xaxis: { categories: machineArr.map(([name]) => name) },
              dataLabels: { enabled: true, formatter: fmtMins },
              grid: { borderColor: "#f0f2f5", padding: { right: 50 } },
              tooltip: { y: { formatter: fmtMins } },
            }}
            height={Math.max(220, machineArr.length * 42)}
          />
          <div
            style={{
              position: "absolute",
              top: 15,
              right: 15,
              bottom: 40,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {machineArr.map(([name, data], idx) => (
              <div
                key={idx}
                style={{ flex: 1, display: "flex", alignItems: "center" }}
              >
                <IconButton
                  icon={<FiPlus />}
                  appearance="primary-subtle"
                  label="Hurda Girişi Yap"
                  onClick={() => {
                    if (data.id) {
                      navigate("/epc", {
                        state: {
                          machine: { _id: data.id, name: name },
                          action: "scrap",
                        },
                      });
                    }
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </CardContainer>
    );
  };

  return (
    <DowntimeReportShell
      title="Makine Duruş Raporu"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={fetchData}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </DowntimeReportShell>
  );
};

export default withAuth(DowntimeByMachineReport);
